import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { BaseProps } from '../common/props';

type Props = BaseProps & {};

/**
 * Tollbar - wrapper pro více akčních tlačítek - tlačítka jsou oddělena mezerou - jedná se o více samostatných tlačítek.
 */
export const ButtonToolbar: React.FC<Props> = ({
  className,
  children,
  ...other
}) => {
  let cls = classNames(className, Classes.BUTTON_TOOLBAR, {});

  return (
    <div className={cls} {...other}>
      {children}
    </div>
  );
};
